import {
  DIGITAL_TRAP_ANALYSIS_PER_FIELD_ICON,
  DIGITAL_TRAP_PIN_CONTAINER,
  DIGITAL_TRAP_PIN_ICON
} from '@features/regional-overview/digital-traps/domain/tests-id.constants';
import { ReactComponent as Pin } from '@features/regional-overview/assets/digital-traps/pin.svg';
import { ReactComponent as TrapAnalysisPerField } from '@features/regional-overview/assets/digital-traps/trap-analysis-per-field-icon.svg';
import styles from '../network-management.module.css';

export const TrapPin = () => {
  return (
    <div className={styles.pinContainer} data-testid={DIGITAL_TRAP_PIN_CONTAINER}>
      <Pin className={styles.pinIcon} data-testid={DIGITAL_TRAP_PIN_ICON} />
      <TrapAnalysisPerField className={styles.trapAnalysisPerFieldIcon} data-testid={DIGITAL_TRAP_ANALYSIS_PER_FIELD_ICON} />
    </div>
  );
};
